/**
 * PermanentDeleteModal Component
 * Confirmation dialog for permanent user deletion
 */
import React, { useState } from 'react';
import './PermanentDeleteModal.css';

function PermanentDeleteModal({ user, onConfirm, onCancel, blockers = [] }) {
  const [confirmUsername, setConfirmUsername] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (confirmUsername !== user.username) {
      alert('Username does not match. Please type the exact username.');
      return;
    }
    
    setIsDeleting(true);
    await onConfirm(confirmUsername);
    setIsDeleting(false);
  };

  const canProceed = confirmUsername === user.username && blockers.length === 0;

  return (
    <div className="modal-overlay">
      <div className="modal-content permanent-delete-modal">
        <h2>⚠️ Permanent Deletion Warning</h2>
        
        <div className="warning-box">
          <p><strong>You are about to permanently delete:</strong></p>
          <ul>
            <li><strong>Username:</strong> {user.username}</li>
            <li><strong>Full Name:</strong> {user.full_name}</li>
            <li><strong>Role:</strong> {user.role}</li>
          </ul>
        </div>

        {blockers.length > 0 ? (
          <div className="blockers-box">
            <h3>❌ Cannot Delete - Blockers Found:</h3>
            <ul>
              {blockers.map((blocker, idx) => (
                <li key={idx}>{blocker}</li>
              ))}
            </ul>
            <p><em>Please resolve these issues before attempting deletion.</em></p>
          </div>
        ) : (
          <>
            <div className="danger-box">
              <h3>⚠️ This action is IRREVERSIBLE!</h3>
              <p>The following data will be permanently deleted:</p>
              <ul>
                <li>User account and credentials</li>
                <li>User settings and preferences</li>
                <li>All associated data</li>
              </ul>
              <p><strong>This cannot be undone!</strong></p>
            </div>

            <div className="confirmation-input">
              <label>
                Type <strong>{user.username}</strong> to confirm:
              </label>
              <input
                type="text"
                value={confirmUsername}
                onChange={(e) => setConfirmUsername(e.target.value)}
                placeholder="Enter username"
                autoFocus
              />
            </div>
          </>
        )}

        <div className="modal-actions">
          {blockers.length === 0 && (
            <button
              onClick={handleConfirm}
              disabled={!canProceed || isDeleting}
              className="btn-danger"
            >
              {isDeleting ? 'Deleting...' : 'Permanently Delete'}
            </button>
          )}
          <button onClick={onCancel} className="btn-secondary">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default PermanentDeleteModal;
